import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  DASHBOARD_APPROVAL_ACL,
  RNC,
  RNCAPPROVED,
  RNCREJECTED,
  SALES,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";
import CustomSelect from "../../../../components/main_comps/custom_select";
import custom_getvalue from "../../../../components/main_comps/custom_getvalue";

function BusinessDetails({
  clientData,
  isEditClicked,
  onChange,
  role,
  status,
}) {
  const [gstNumber, setGstNumber] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [webLink, setWebLink] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [gstValidate, setGstValidate] = useState(false);
  const [gstloading, setGstLoading] = useState(false);
  const [websiteValidate, setWebsiteValidate] = useState(false);

  const [websiteloading, setWebsiteLoading] = useState(false);
  const [legalName, setLegalName] = useState("");
  const [dinNumber, setDinNumber] = useState("");
  const [dpan, setDpan] = useState("");
  const [industryType, setIndustryType] = useState({});
  const aclData = useSelector((state) => state.aclSlice.aclList);

  const Categories = [
    {
      label: "Sole proprietorship",
      value: "SoleProprietorship",
    },
    {
      label: "Partnership",
      value: "Partnership",
    },
    {
      label: "Public",
      value: "Public",
    },
    {
      label: "Private Limited",
      value: "PrivateLimited",
    },
  ];

  const IndustryTypes = [
    {
      label: "Corporate",
      value: "Corporate",
    },
    {
      label: "Crypto",
      value: "Crypto",
    },
    {
      label: "Gaming",
      value: "Gaming",
    },
  ];

  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    maxWidth: 500,
    minWidth: 250,
    width: 350,
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  useEffect(() => {
    if (!isEditClicked) {
      setWebLink(clientData?.websiteLink);
      setGstNumber(clientData?.gstNumber);
      setBusinessType({
        label: clientData?.businessType,
        value: clientData?.businessType,
      });
      setBusinessName(clientData?.businessName);
      setBusinessAddress(clientData?.address);
      setLegalName(clientData.legalName);
      setDinNumber(clientData.dinNumber);
      setDpan(clientData.dpan);
      setIndustryType({
        label: clientData?.industryType,
        value: clientData?.industryType,
      });
    }
  }, [isEditClicked, clientData]);

  useEffect(() => {
    onChange({
      gstNumber: custom_getvalue(gstNumber, clientData?.gstNumber),
      businessType: custom_getvalue(
        businessType?.value,
        clientData?.businessType
      ),
      webLink: custom_getvalue(webLink, clientData?.webLink),
      businessName: custom_getvalue(businessName, clientData?.businessName),
      businessAddress: custom_getvalue(businessAddress, clientData?.address),
      legalName: custom_getvalue(legalName, clientData.legalName),
      dinNumber: custom_getvalue(dinNumber, clientData.dinNumber),
      dpan: custom_getvalue(dpan, clientData.dpan),
      industryType: custom_getvalue(
        industryType?.value,
        clientData.industryType
      ),
    });
  }, [
    gstNumber,
    businessType,
    webLink,
    businessName,
    businessAddress,
    legalName,
    dinNumber,
    dpan,
    industryType,
  ]);

  return (
    <div>
      <div
        style={{
          marginLeft: "2%",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Business Name
          </label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={businessName}
            onChange={(data) => {
              if (!isEditClicked) {
                setBusinessName(clientData?.businessName);
              } else {
                setBusinessName(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Business Name"
            validator="businessName"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={35}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>GST Number</label>
          <div style={{ display: "flex" }}>
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              value={gstNumber}
              onChange={(data) => {
                if (!isEditClicked) {
                  setGstNumber(clientData?.gstNumber);
                } else {
                  setGstNumber(data);
                }
              }}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="GST Number"
              validator="gst"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
            {/* 
            {role === RNC &&
              status !== RNCREJECTED &&
              status !== RNCAPPROVED && (
                <>
                  {gstloading ? (
                    <div
                      style={{
                        // marginTop: "5px",
                        // marginLeft: "10px",
                        paddingLeft: 10,
                        paddingTop: 10,
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    <CustomButton
                      title={gstValidate ? "Verified" : "Validate"}
                      onClick={() => {
                        if (!gstValidate) {
                          setGstLoading(true);
                          // validateAccountWithPennyDrop({
                          //   accNo: remitterAccountNumber,
                          //   ifsc: remitterAccountIfsc,
                          //   name: remitterAccountName,
                          // });
                        }
                      }}
                      styles={{
                        alignSelf: "flex-end",
                        marginBottom: 10,
                        marginLeft: 7,
                      }}
                    />
                  )}
                </>
              )} */}
          </div>
        </div>

        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <div style={{ width: "fit-content" }}>
            <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
              Business Type
            </label>

            <CustomSelect
              disabled={isEditClicked ? "" : "disabled"}
              value={businessType}
              options={Categories}
              placeholder={"Select the Category"}
              style={{
                ...containerStyle,
                backgroundColor: "white",
                position: "",
              }}
              onChange={(data) => {
                if (!isEditClicked) {
                  setBusinessType({
                    label: clientData?.businessType,
                    value: clientData?.businessType,
                  });
                } else {
                  setBusinessType(data);
                  // setBusinessType({
                  //   label: data?.label,
                  //   value: data?.value,
                  // });
                }
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, lineHeight: 2 }}>Website Link</label>
          <div style={{ display: "flex" }}>
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              value={webLink}
              onChange={(data) => {
                if (!isEditClicked) {
                  setWebLink(clientData?.websiteLink);
                } else {
                  setWebLink(data);
                }
              }}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter Website Link"
              validator=""
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
            {/* {role === RNC &&
              status !== RNCREJECTED &&
              status !== RNCAPPROVED && (
                <>
                  {websiteloading ? (
                    <div
                      style={{
                        // marginTop: "5px",
                        // marginLeft: "10px",
                        paddingLeft: 10,
                        paddingTop: 10,
                      }}
                    >
                      <CustomLoader />
                    </div>
                  ) : (
                    <CustomButton
                      title={websiteValidate ? "Verified" : "Validate"}
                      onClick={() => {
                        if (!websiteValidate) {
                          setWebsiteLoading(true);
                          // validateAccountWithPennyDrop({
                          //   accNo: remitterAccountNumber,
                          //   ifsc: remitterAccountIfsc,
                          //   name: remitterAccountName,
                          // });
                        }
                      }}
                      styles={{
                        alignSelf: "flex-end",
                        marginBottom: 10,
                        marginLeft: 7,
                      }}
                    />
                  )}
                </>
              )} */}
          </div>
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Business Address
          </label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={businessAddress}
            onChange={(data) => {
              if (!isEditClicked) {
                setBusinessAddress(clientData?.address);
              } else {
                setBusinessAddress(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Business Address"
            validator="address"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={35}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            Legal Name
          </label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={legalName}
            onChange={(data) => {
              if (!isEditClicked) {
                setLegalName(clientData?.legalName);
              } else {
                setLegalName(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Legal Name"
            validator="businessName"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={35}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <div style={{ width: "fit-content" }}>
            <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
              Industry Type
            </label>

            <CustomSelect
              disabled={isEditClicked ? "" : "disabled"}
              value={industryType}
              options={IndustryTypes}
              placeholder={"Select the Indutry Type"}
              style={{
                ...containerStyle,
                backgroundColor: "white",
                position: "",
              }}
              onChange={(data) => {
                if (!isEditClicked) {
                  setIndustryType({
                    label: clientData?.industryType,
                    value: clientData?.industryType,
                  });
                } else {
                  setIndustryType(data);
                }
              }}
            />
          </div>
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            DIN Check
          </label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={dinNumber}
            onChange={(data) => {
              if (!isEditClicked) {
                setDinNumber(clientData?.dinNumber);
              } else {
                setDinNumber(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="DIN Check"
            validator="din"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={35}
          />
        </div>
        <div style={{ marginTop: 20, width: "50%", minWidth: "400px" }}>
          <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2 }}>
            DPAN Check
          </label>
          <CustomInput
            disabled={isEditClicked ? "" : "disabled"}
            value={dpan}
            onChange={(data) => {
              if (!isEditClicked) {
                setDpan(clientData?.dpan);
              } else {
                setDpan(data);
              }
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="DPAN Check"
            validator="pan"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            maxLength={35}
          />
        </div>
      </div>
    </div>
  );
}

export default BusinessDetails;
